import React from "react";
import { Link } from "react-router-dom";

export default class ReportTabs extends React.Component {
  render() {
    let nav = {
      new: "Новый",
      recent: "Недавние",
    };

    const { itemId, nodeId, mode, itemMode } = this.props;
    return (
      <ul className="nav nav-tabs mb-4">
        {Object.entries(nav).map(([id, title]) => (
          <li className="nav-item w-lg-auto w-100" key={id}>
            <Link
              to={`/report/${mode}/${nodeId}/${itemId}/${id}/`}
              className={` ${
                itemMode === id ? "active" : ""
              } cursor-pointer nav-link`}
            >
              {title}
            </Link>
          </li>
        ))}
      </ul>
    );
  }
}
